<ng-container *ngIf="vm$ | async as vm; else authLoading">
	<div class="forge-shell">
		<div class="forge-shell__noise" aria-hidden="true"></div>

		<app-nav-bar [vm]="vm"></app-nav-bar>

		<main class="forge-main">
			<div class="forge-main__content">
				<router-outlet></router-outlet>
			</div>
		</main>

		<footer class="forge-footer">&copy; {{ currentYear }} Omniscient Forge &bull; Crafted for Foundry VTT</footer>
	</div>
</ng-container>

<ng-template #authLoading>
	<app-nav-bar [vm]="null"></app-nav-bar>
	<router-outlet></router-outlet>
</ng-template>